import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "917259886651";
const PREFILL = "Hi KNOVAS, I'd like to enquire about your hardware range.";

export default function FloatingWhatsApp() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILL)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat with KNOVAS on WhatsApp"
      className="group fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[90] flex items-center gap-0 hover:gap-3 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full shadow-lg hover:shadow-xl pl-4 pr-4 h-14 transition-all duration-300"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-11 w-11 rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden />
        <MessageCircle size={24} className="relative" fill="currentColor" strokeWidth={0} />
      </span>
      <span className="max-w-0 group-hover:max-w-[160px] overflow-hidden whitespace-nowrap text-xs font-bold uppercase tracking-[0.2em] transition-all duration-300">
        Chat on WhatsApp
      </span>
    </a>
  );
}
